import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';

import { selectStepAfterTransitionWord } from '../../../selectors/step-after-transition-word.selector.ts';
import { selectStepBeforeTransitionWord } from '../../../selectors/step-before-transition-word.selector.ts';
import { selectStepFirstWord } from '../../../selectors/step-first-word.selector.ts';
import { selectStepLastWord } from '../../../selectors/step-last-word.selector.ts';

import {
  KeyWordIndices,
  KeyWordType,
  STORY_READING_SLICE_NAME,
  StoryReadingSliceState,
} from '../story-reading.slice.types.ts';

export const computeStepWordIndicesThunk = createAsyncThunk<KeyWordIndices, void, ThunkApiConfigType>(
  `${STORY_READING_SLICE_NAME}/computeStepWordIndicesThunk`,
  (_, { getState }): KeyWordIndices => {
    const state = getState();
    const firstWord = selectStepFirstWord(state);
    const lastWord = selectStepLastWord(state);
    const beforeTransitionWord = selectStepBeforeTransitionWord(state);
    const afterTransitionWord = selectStepAfterTransitionWord(state);

    const indices: KeyWordIndices = {
      [KeyWordType.STEP_FIRST_WORD]: firstWord,
      [KeyWordType.STEP_LAST_WORD]: lastWord,
      [KeyWordType.STEP_BEFORE_TRANSITION_WORD]: beforeTransitionWord,
      [KeyWordType.STEP_AFTER_TRANSITION_WORD]: afterTransitionWord,
    };

    return indices;
  }
);

export const computeStepWordIndicesThunkExtraReducers = (
  builder: ActionReducerMapBuilder<StoryReadingSliceState>
): ActionReducerMapBuilder<StoryReadingSliceState> =>
  builder.addCase(computeStepWordIndicesThunk.fulfilled, (state, action) => {
    state.keyWordIndices = action.payload;
  });
